import { render } from "./raqam.vue?vue&type=template&id=a6e58b64"
import script from "./raqam.vue?vue&type=script&lang=js"
export * from "./raqam.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__